import React from "react";
import Logo from "@/components/Logo";
import { InstagramLogo, FacebookLogo, WhatsappLogo, PhoneCall, EnvelopeSimple, MapPin } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-mg bg-mg-2 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <img
            src="/brand/moonglow-logo.png"
            alt="MoonGlow Screens · Private Theater"
            className="h-24 w-auto"
            draggable={false}
          />
          <p className="mt-6 text-sm text-white/60 leading-relaxed max-w-xs">
            A luxurious private movie experience for every occasion.
          </p>
        </div>

        <div>
          <div className="label-tiny mb-4">Occasions</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Birthdays</li>
            <li>Marriage Proposals</li>
            <li>Anniversaries</li>
            <li>Surprise Parties</li>
            <li>Family Gatherings</li>
            <li>Friends Get-togethers</li>
          </ul>
        </div>

        <div>
          <div className="label-tiny mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-2"><PhoneCall size={16} className="text-gold" /> +91 98765 43210</li>
            <li className="flex items-center gap-2"><EnvelopeSimple size={16} className="text-gold" /> hello@moonglowscreens.com</li>
            <li className="flex items-start gap-2"><MapPin size={16} className="text-gold mt-0.5" /> Level 3, MoonGlow Arcade, Kukatpally, Hyderabad</li>
          </ul>
        </div>

        <div>
          <div className="label-tiny mb-4">Follow the Glow</div>
          <div className="flex items-center gap-4 text-white/70">
            <InstagramLogo size={22} className="hover:text-gold transition-colors" />
            <FacebookLogo size={22} className="hover:text-gold transition-colors" />
            <WhatsappLogo size={22} className="hover:text-gold transition-colors" />
          </div>
          <div className="mt-6 text-xs text-white/40">
            © {new Date().getFullYear()} MoonGlow Screens. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
